import { connectCustom } from "@client/lib/misc";
import { type AppState, type WithId } from "@client/types";
import { type Leaderboard } from "../../types";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = WithId & {
  onCloseClick?: () => void;
  item: Leaderboard.Item;
};
const makeMapStateToProps = () => {
  return (state: AppState, props: Props): MapProps => {
    return {
      item: props.item
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onCloseClick: props.onCloseClick
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
